import { Button } from '@synoptic/ui-kit/button/button.tsx';
import { Input } from '@synoptic/ui-kit/input/input.tsx';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.tsx';
import { confirmSignIn } from 'aws-amplify/auth';
import { FC, useRef, useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import {
  cardBody,
  formFieldsContainer,
  formHeading,
  submitAuthFormButton,
} from '../_auth/page.css';

type FormInputs = {
  code: string;
};

export const ConfirmLoginForm: FC<{ onLoginConfirm: () => void }> = ({
  onLoginConfirm,
}) => {
  const { handleSubmit, register } = useForm<FormInputs>();
  const formRef = useRef<HTMLFormElement>(null);
  const toast = useToast();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submit: SubmitHandler<FormInputs> = async (data) => {
    setIsSubmitting(true);

    const { code } = data;
    try {
      await confirmSignIn({
        challengeResponse: code,
      });

      onLoginConfirm();
    } catch (e) {
      setIsSubmitting(false);
      toast.error({ title: String(e) });
    }
  };

  return (
    <form ref={formRef} onSubmit={handleSubmit(submit)}>
      <h1 className={formHeading}>Two-factor authentication</h1>
      <p className={cardBody}>
        Enter the 6-digit verification code generated by the authenticator app.
      </p>
      <div className={formFieldsContainer}>
        <Input
          {...register('code', {
            required: true,
          })}
          placeholder={'Enter the verification code'}
          autoComplete={'off'}
          label={'Verification code'}
          autoFocus
        />
        <Button
          className={submitAuthFormButton}
          size={'large'}
          type="submit"
          loading={isSubmitting}
        >
          Verify and continue
        </Button>
      </div>
    </form>
  );
};
